<template>
  <v-app>
    <Header/>
    <Sidebar/>
    <v-content>
      <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
        <v-layout>
          <v-flex text-xs-left xs12 md3 px-3>
            <v-text-field v-model="search" append-icon="search" placeholder="Search" v-if="!currentCategory" style="padding-bottom: 0 !important;"></v-text-field>
          </v-flex>
          <v-flex text-xs-right xs12 md9>
            <v-btn flat v-if="!currentCategory" @click="toggleFilterInactive(false)" class="bw-4" :style="buttonStyleFilterActive" :disabled="!filterInactive">Active</v-btn>
            <v-btn flat v-if="!currentCategory" @click="toggleFilterInactive(true)" class="bw-4" :style="buttonStyleFilterInactive" :disabled="filterInactive" style="margin-right: 50px;">Inactive</v-btn>
            <v-btn flat v-if="!currentCategory" v-on:click="editNewCategory" class="bw-7">Create new category</v-btn>
            <v-btn flat v-if="currentCategory" :disabled="saveButtonDisabled" v-on:click="save" class="bw-3">{{ currentCategory.id > 0 ? 'Save' : 'Create' }}</v-btn>
            <v-btn flat v-if="canDelete" v-on:click="confirmDeleteDialog = true" class="bw-3">Delete</v-btn>
            <v-btn flat v-if="currentCategory" v-on:click="cancel" class="bw-3">Cancel</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-2 px-3 v-show="!currentCategory" >
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
            <v-data-table :headers="headers" :items="filteredCategories" :search="search" hide-actions>
              <template v-slot:items="props">
                <tr @click="selectCategory(props.item)" class="selectable">
                  <td class="text-xs-left" width="100px">{{ props.item.quality }}</td>
                  <td class="text-xs-left" v-if="!(props.item.color.secondColor && props.item.color.secondColor !== '')">
                    <div :style="'margin: 2px; border-radius: 3px; border: 1px solid #BBBBBB; padding: 4px 5px; text-align: center; width: 100% !important; background-color: #' + props.item.color.color + ';'">&nbsp;</div>
                  </td>
                  <td class="text-xs-left" v-if="props.item.color.secondColor && props.item.color.secondColor !== ''">
                    <div :style="'margin: 2px; border-radius: 3px; border: 1px solid #BBBBBB; padding: 4px 5px; text-align: center; width: 100% !important; background: repeating-linear-gradient(-45deg, #' + props.item.color.color + ', #' + props.item.color.color + ' 3px, #' + props.item.color.secondColor + ' 3px, #' + props.item.color.secondColor + ' 6px);'">&nbsp;</div>
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.label }}
                    <v-icon v-if="props.item.image" class="tag" style="font-size: 14px; padding-left: 10px;" @click.stop="showCategoryImage(props.item.image)">fa-tag</v-icon>
                  </td>
                  <td class="text-xs-left">
                    <template v-for="(categoryFamily, i) in props.item.families">
                      <div :key="'fv_' + i" style="padding: 1px 0;">
                        {{ categoryFamily.family.displayLabel }}&nbsp;&nbsp;&nbsp;({{ categoryFamily.value }} %)
                      </div>
                    </template>
                  </td>
                  <td class="text-xs-left">{{ props.item.palletAmount }}</td>
                  <td class="text-xs-left">{{ props.item.halfPalletAmount }}</td>
                  <td class="text-xs-left">{{ props.item.productNumber }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>

      <Panel v-if="currentCategory">
        <PanelColumn title="Category" first="true">
          <v-flex xs12 sm3 md2>
            <v-label>Quality</v-label>
          </v-flex>
          <v-flex xs12 sm4 md2>
            <v-text-field color="teal" v-model="currentCategory.quality" ref="quality" autocomplete="offit"></v-text-field>
          </v-flex>
          <v-flex xs0 sm5 md8 style="height: 10px;">&nbsp;</v-flex>

          <v-flex xs12 sm3 md2 style="height: 36px;">
            <v-label>Color</v-label>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-select :items="colors" v-model="currentCategory.color" item-text="name" return-object>
              <template slot="selection" slot-scope="data">
                <div v-if="!(data.item.secondColor && data.item.secondColor !== '')" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color + ';'"></div>
                <div v-if="data.item.secondColor && data.item.secondColor !== ''" :style="'margin: 3px 10px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color + ', #' + data.item.color + ' 3px, #' + data.item.secondColor + ' 3px, #' + data.item.secondColor + ' 6px);'"></div>
                {{ data.item.name }}
              </template>
              <template slot="item" slot-scope="data">
                <div v-if="!(data.item.secondColor && data.item.secondColor !== '')" :style="'margin: 3px 10px 3px 0; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + data.item.color + ';'"></div>
                <div v-if="data.item.secondColor && data.item.secondColor !== ''" :style="'margin: 3px 10px 3px 0; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + data.item.color + ', #' + data.item.color + ' 3px, #' + data.item.secondColor + ' 3px, #' + data.item.secondColor + ' 6px);'"></div>
                {{ data.item.name }}
              </template>
            </v-select>
          </v-flex>
          <v-flex xs0 sm3 md6 style="height: 10px;">&nbsp;</v-flex>

          <v-flex xs12 sm3 md2>
            <v-label>Label</v-label>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-text-field color="teal" v-model="currentCategory.label" autocomplete="offit"></v-text-field>
          </v-flex>
          <v-flex xs0 sm3 md5 style="height: 10px;">&nbsp;</v-flex>

          <v-flex xs12 sm3 md2>
            <v-label>Pallet amount</v-label>
          </v-flex>
          <v-flex xs12 sm3 md1>
            <v-text-field color="teal" v-model="currentCategory.palletAmount" autocomplete="offit"></v-text-field>
          </v-flex>
          <v-flex xs0 sm6 md9 style="height: 10px;">&nbsp;</v-flex>

          <v-flex xs12 sm3 md2>
            <v-label>Half pallet amount</v-label>
          </v-flex>
          <v-flex xs12 sm3 md1>
            <v-text-field color="teal" v-model="currentCategory.halfPalletAmount" autocomplete="offit"></v-text-field>
          </v-flex>
          <v-flex xs0 sm6 md9 style="height: 10px;">&nbsp;</v-flex>

          <v-flex xs12 sm3 md2>
            <v-label>Product number</v-label>
          </v-flex>
          <v-flex xs12 sm9 md10 style="height: 35px;">
            <v-text-field v-model="currentCategory.productNumber" type="text" maxlength="100" style="max-width: 180px;"/>
          </v-flex>

          <v-flex xs12 sm3 md2>
            <v-label>Family</v-label>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <template v-for="(categoryFamily, i) in currentCategory.families">
              <v-autocomplete :items="families" v-model="categoryFamily.family" :key="'ff_' + i" item-text="displayLabel" return-object style="height: 35px;"/>
            </template>
          </v-flex>
          <v-flex xs12 sm3 md6>
            <template v-for="(categoryFamily, i) in currentCategory.families">
              <div :key="'fv_' + i" :style="($vuetify.breakpoint.smAndUp ? 'padding-left: 20px;' : '') + 'padding-top: 5px;'">
                <table class="noPadding">
                  <tr>
                    <td>
                      <v-text-field v-model="categoryFamily.value" type="text" maxlength="3" class="alignRight rightPadding" style="max-width: 60px; height: 30px;"/>
                    </td>
                    <td style="vertical-align: top; padding-left: 10px; padding-top: 3px;">%</td>
                    <td style="padding-left: 15px;">
                      <v-icon @click="deleteFamily(i)" title="Delete">delete</v-icon>
                    </td>
                  </tr>
                </table>
              </div>
            </template>
          </v-flex>
          <v-flex xs12 sm3 md2></v-flex>
          <v-flex xs12 sm9 md10>
            <v-btn flat class="bw-5" @click='addFamily' style="margin-left: 0;">Add family</v-btn>
          </v-flex>
          <v-flex xs12>
            <div style="height: 20px;"></div>
          </v-flex>

          <v-flex xs12 sm3 md2>
            <v-label>Inactive</v-label>
          </v-flex>
          <v-flex xs12 sm3 md1>
            <v-checkbox color="teal" v-model="currentCategory.inactive"/>
          </v-flex>
          <v-flex xs0 sm6 md9 style="height: 10px;">&nbsp;</v-flex>

          <v-flex xs12 sm3 md2>
            <v-label>Image</v-label>
          </v-flex>
          <v-flex xs12 sm9 md10 :key="'imageButtons_' + updateCounter">
            <v-btn flat class="bw-5" @click='selectImage' style="margin-left: 0;">{{ hasImage || hasNewImage ? 'Change image' : 'Select image' }}</v-btn>
            <v-btn flat class="bw-5" @click='deleteImage' style="margin-left: 0;" v-if="hasImage || hasNewImage">Delete image</v-btn>
            <v-btn flat class="bw-icon" @click='rotateLeft' style="margin-left: 0;" v-if="hasImage"><v-icon>fa-undo</v-icon></v-btn>
            <v-btn flat class="bw-icon" @click='rotateRight' style="margin-left: 0;" v-if="hasImage"><v-icon>fa-redo</v-icon></v-btn>

            <v-spacer style="height: 5px;"></v-spacer>
            <img :src="this.currentCategory.image" style="max-width: 90%; max-height: 400px;" v-if="hasNewImage"/>
            <img :src="completeImageUrl" style="max-width: 90%; max-height: 400px;" v-if="hasImage" :key="'img_' + updateCounter"/>
            <input type="file" style="display: none" ref="image" accept=".png, .jpg, .jpeg" @change="onFilePicked"/>
          </v-flex>
        </PanelColumn>
      </Panel>
    </v-content>
    <Footer/>

    <v-dialog v-model="confirmDeleteDialog" persistent width="350">
      <v-card pa-5>
        <v-card-title class="headline">Delete category</v-card-title>
        <v-card-text v-if="currentCategory">Are you sure you want to delete this category?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="this.delete">Yes</v-btn>
          <v-btn flat @click="confirmDeleteDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div style="background-color: rgba(0, 0, 0, 0.25); position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;" @click="showCategoryImageDialog = false" v-if="showCategoryImageDialog">
      <img :src="categoryImageUrl" style="max-width: 80%; max-height: 80%; border: 5px solid white; border-radius: 5px;"/>
    </div>

    <ErrorDialog ref="errorDialog"/>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import Panel from '../components/Panel'
import PanelColumn from '../components/PanelColumn'
import ErrorDialog from '../components/ErrorDialog'
import NumberUtil from '@/assets/javascript/numberutil'
import axios from 'axios'

export default {
  name: 'Categories',
  components: { Header, Sidebar, Footer, Panel, PanelColumn, ErrorDialog },
  data () {
    return {
      search: '',
      headers: [
        { text: 'Quality', value: 'quality', sortable: false },
        { text: 'Color', value: 'color.name', align: 'center', width: '100', sortable: false },
        { text: 'Label', value: 'label', sortable: false },
        { text: 'Family', sortable: false },
        { text: 'Pallet amount', value: 'palletAmount', width: '100', sortable: false },
        { text: 'Half pallet amount', value: 'halfPalletAmount', width: '100', sortable: false },
        { text: 'Product number', value: 'productNumber', width: '150', sortable: false }
      ],
      categories: [],
      colors: [],
      families: [],
      currentCategory: null,
      confirmDeleteDialog: false,
      filterInactive: false,
      showCategoryImageDialog: false,
      categoryImageUrl: '',
      updateCounter: 1
    }
  },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', { key: 'categories' })
    this.loadCategories()
  },
  computed: {
    saveButtonDisabled: function () {
      return !this.currentCategory || this.currentCategory.quality.trim() === '' || this.currentCategory.color.id <= 0 || this.currentCategory.label.trim() === '' || !NumberUtil.isPositiveInteger(this.currentCategory.palletAmount) || !NumberUtil.isPositiveInteger(this.currentCategory.halfPalletAmount) || !this.areFamiliesOk
    },
    areFamiliesOk: function () {
      if (this.currentCategory && this.currentCategory.families && this.currentCategory.families.length) {
        let sum = 0
        for (let f of this.currentCategory.families) {
          if (!f.family || !NumberUtil.isPositiveInteger(f.value)) {
            return false
          }
          sum += Number(f.value)
        }
        return sum === 100
      }
      return true
    },
    canDelete: function () {
      return this.currentCategory && this.currentCategory.id > 0
    },
    hasImage: function () {
      return this.currentCategory && this.currentCategory.image != null && this.currentCategory.image !== '' && this.currentCategory.image !== 'x' && !this.currentCategory.image.startsWith('data:')
    },
    hasNewImage: function () {
      return this.currentCategory && this.currentCategory.image != null && this.currentCategory.image !== '' && this.currentCategory.image.startsWith('data:')
    },
    completeImageUrl: function () {
      return this.hasImage ? '/backend/image/' + this.currentCategory.image : ''
    },
    buttonStyleFilterActive () {
      return (this.filterInactive === false ? ' color: #606060 !important;' : '')
    },
    buttonStyleFilterInactive () {
      return (this.filterInactive === true ? ' color: #606060 !important;' : '')
    },
    filteredCategories () {
      return this.categories.filter(c => this.filterInactive ? c.inactive : !c.inactive)
    }
  },
  methods: {
    loadColors () {
      // console.log('Loading colors')
      axios.get('/backend/rest/color')
        .then(response => {
          // console.log('Response data: ' + Object.keys(response))
          this.colors = response.data
          // console.log('Colors: ' + this.colors)
        })
    },
    loadFamilies () {
      axios.get('/backend/rest/family')
        .then(response => {
          this.families = response.data
        })
    },
    loadCategories () {
      // console.log('Loading categories')
      axios.get('/backend/rest/category/all')
        .then(response => {
          // console.log('Response data: ' + Object.keys(response))
          this.categories = response.data
          // console.log('Categories: ' + this.categories)
        })
    },
    selectCategory (item) {
      this.loadColors()
      this.loadFamilies()
      for (let c of this.categories) {
        if (c.id === item.id) {
          this.currentCategory = c
          break
        }
      }
      // console.log('The current category is: ' + this.currentCategory.id)
    },
    async editNewCategory () {
      // console.log('Create a new category')
      await this.loadColors()
      await this.loadFamilies()
      this.currentCategory = {
        id: 0,
        quality: '',
        color: {
          id: 0,
          name: '',
          color: ''
        },
        label: '',
        palletAmount: 0,
        halfPalletAmount: 0,
        productNumber: '',
        image: ''
      }
      this.addFamily()
      this.$nextTick(() => this.$refs.quality.focus())
    },
    async save () {
      // console.log('Save the category')
      await axios.post('/backend/rest/category', this.currentCategory)
        .then(response => {
          // console.log('Got response: ' + response)
          this.loadCategories()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })

      if (this.hasNewImage) {
        await axios.get('/backend/rest/category/' + this.currentCategory.id)
          .then(response => {
            this.currentCategory = response.data
            this.updateCounter++
          })
      } else {
        this.currentCategory = null
      }
    },
    delete () {
      // console.log('Delete category: ' + this.currentCategory.id)

      axios.delete('/backend/rest/category/' + this.currentCategory.id)
        .then(response => {
          // console.log('Got response: ' + response)

          this.loadCategories()
        })
        .catch(error => {
          console.log(error.response.data.message)
          this.$refs.errorDialog.errorTitle = 'Delete error'
          this.$refs.errorDialog.errorMessage = 'Could not delete category, it might be used'
          this.$refs.errorDialog.errorDialog = true
        })

      this.confirmDeleteDialog = false
      this.currentCategory = null
    },
    cancel () {
      // console.log('Cancel the category')
      this.currentCategory = null
      this.loadCategories()
    },
    selectImage () {
      this.$refs.image.click()
    },
    onFilePicked (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        let imageName = files[0].name
        if (imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.currentCategory.image = fr.result
        })
      }
    },
    deleteImage () {
      this.currentCategory.image = 'x'
    },
    async rotateLeft () {
      let imageRotation = {
        imageId: this.currentCategory.image,
        clockwise: false
      }
      await axios.post('/backend/rest/image/rotate', imageRotation)
      await axios.get('/backend/rest/category/' + this.currentCategory.id)
        .then(response => {
          this.currentCategory = response.data
          this.updateCounter++
        })
      this.loadCategories()
    },
    async rotateRight () {
      let imageRotation = {
        imageId: this.currentCategory.image,
        clockwise: true
      }
      await axios.post('/backend/rest/image/rotate', imageRotation)
      await axios.get('/backend/rest/category/' + this.currentCategory.id)
        .then(response => {
          this.currentCategory = response.data
          this.updateCounter++
        })
      this.loadCategories()
    },
    toggleFilterInactive (inactive) {
      this.filterInactive = inactive
    },
    addFamily (setDefaultFamily = true) {
      if (this.currentCategory) {
        if (!this.currentCategory.families) {
          this.currentCategory.families = []
        }
        let valueSum = 0
        for (let f of this.currentCategory.families) {
          if (f.value && f.value !== '') {
            valueSum += Number(f.value)
          }
        }
        this.currentCategory.families.push(
          {
            id: 0,
            family: setDefaultFamily && this.families && this.families.length ? this.families[0] : null,
            value: 100 - Math.min(valueSum, 100)
          }
        )
      }
    },
    deleteFamily (index) {
      if (this.currentCategory.families && index < this.currentCategory.families.length) {
        this.currentCategory.families.splice(index, 1)
      }
    },
    showCategoryImage: function (imageUuid) {
      this.categoryImageUrl = '/backend/image/' + imageUuid
      this.showCategoryImageDialog = true
    }
  }
}
</script>
<style scoped>
  html {
    overflow-y: auto;
  }
  .v-input {
    padding-top: 0;
    margin-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Categories.vue